var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.75C12.5188 9.75 13.75 8.51878 13.75 7C13.75 5.48122 12.5188 4.25 11 4.25C9.48122 4.25 8.25 5.48122 8.25 7C8.25 8.51878 9.48122 9.75 11 9.75Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9649 2.06633C15.0863 0.778125 13.0758 0.125 10.9897 0.125C9.11238 0.125 7.28234 0.683594 5.55027 1.77844C3.80359 2.88488 2.09129 4.89453 0.6875 7C1.82273 8.89062 3.37562 10.8345 4.99297 11.9491C6.84836 13.227 8.86574 13.875 10.9897 13.875C13.0952 13.875 15.1082 13.2275 16.9752 11.9504C18.6188 10.8242 20.1829 8.88289 21.3125 7C20.179 5.13387 18.6098 3.19469 16.9649 2.06633ZM11 11.125C10.1842 11.125 9.38663 10.8831 8.70827 10.4298C8.02992 9.97655 7.50121 9.33231 7.189 8.57857C6.87679 7.82482 6.7951 6.99542 6.95426 6.19525C7.11342 5.39508 7.50629 4.66008 8.08318 4.08318C8.66008 3.50629 9.39508 3.11343 10.1953 2.95426C10.9954 2.7951 11.8248 2.87679 12.5786 3.189C13.3323 3.50121 13.9766 4.02992 14.4298 4.70827C14.8831 5.38663 15.125 6.18415 15.125 7C15.1237 8.09363 14.6888 9.14212 13.9154 9.91543C13.1421 10.6888 12.0936 11.1237 11 11.125V11.125Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeMenu);
export default __webpack_public_path__ + "static/media/eye_menu.c2b81b68355990c122b1b6d1c9ee8e33.svg";
export { ForwardRef as ReactComponent };